import { Inject, Injectable } from "@angular/core";
// classes
import { ProjectConstants } from "./project.constants";
import { DOCUMENT } from "@angular/common";

@Injectable()
export class EndpointsConstants extends ProjectConstants {
  // base path
  protected BASEPATH = this.apiBasePath;
  // working environment
  protected ORG = this.apiOrg;
  protected ENV = this.apiEnv;
  // versions
  public V1 = "v1/";
  public V2 = "v2/";
  public V3 = "v3/";
  public V4 = "v4/";
  public V5 = "v5/";
  public V6 = "v6/";
  public V7 = "v7/";
  public V8 = "v8/";

  // capabilities
  public armCapability = "arm/";
  public legalCapability = "legal/";
  public dsCapability = "ds/";
  public rcCapability = "rc/";
  public crmCapability = "crm/";
  public cumCapability = "cum/";
  public peCapability = "pe/";
  public repCapability = "rep/";
  public smCapability = "sm/";
  public imCapability = "im/";
  public brmCapability = "brm/";
  public jpMorganCheckout = "v3/brm/payers/jpmorgan/ols";
  public jpMorganNotification = "v3/brm/payers/jpmorgan/notifications/listnotifications";
  public jpMorganPaymentStatus = "v6/int/brm/payments/statuses";
  public jpMorganRedirected = "/invoices-payments/redirect/jpmorgan";

  public BoACheckout = "v3/brm/payers/bofa/ols";
  public BoANotification = "v3/brm/payers/bofa/notifications/listnotifications";
  // public BoAPaymentStatus = "v6/int/brm/payments/statuses";
  public BoARedirected = "/invoices-payments/redirect/bofa";
  // public BoASnapPayment = "https://stage.snappayglobal.com/Interop/InteropRequest?reqno=";
  public BankPaymentStatus = "v6/int/brm/payments/statuses";


  constructor() {
    super();
  }

  // =================================================================================================================
  // Expositions
  // =================================================================================================================

  public getLoginPath(): string {
    const url = this.BASEPATH + this.ORG + this.ENV + this.V2 + "secm/oam/oauth2/token";
    return url;
  }

  public getBasePath(): string {
    return this.BASEPATH + this.ORG + this.ENV;
  }

  public getUserInfoPath(): string {
    const url = this.BASEPATH + this.ORG + this.ENV + this.V5 + "secm/user";
    return url;
  }
}

// @Injectable()
// export class InvoicesPaymentsConstants extends EndpointsConstants {

//     constructor(basepath: string, org: string, env: string) {
//         super(basepath, org, env);
//     }

//     // documentCenter
//     public documentCenterEndpoint(api: string): string {
//         let url = this.BASEPATH + this.ORG + this.ENV + this.V4 + this.dsCapability + api;
//         return url;
//     }

//     public documentCenterEndpointVersion5( api: string ): string {
//         let url = this.BASEPATH + this.ORG + this.ENV + this.V5 + this.dsCapability + api;
//         return url;
//     }

//     public documentCenterEndpointARM( api: string ): string {
//         let url = this.BASEPATH + this.ORG + this.ENV + this.V2 + this.armCapability + api;
//         return url;
//     }

//     // report
//     public reportEndoint(api: string): string {
//         let url = this.BASEPATH + this.ORG + this.ENV + this.V1 + this.rcCapability + api;
//         return url;
//     }

//     // disputes
//     public disputesEndpoint(api: string): string {
//         let url = this.BASEPATH + this.ORG + this.ENV + this.V1 + this.crmCapability + api;
//         return url;
//     }

//     public configurationCountry(api: string): string {
//         let url = this.BASEPATH + this.ORG + this.ENV + this.V1 + this.rcCapability + api;
//         return url;
//     }

//     public userProfileEndpoint(api: string): string {
//         let url = this.BASEPATH + this.ORG + this.ENV + this.V5 + api;
//         return url;
//     }

//     // lienRelease
//     public lienReleaseEndpoint(api: string): string {
//         let url = this.BASEPATH + this.ORG + this.ENV + this.V2 + this.legalCapability + api;
//         return url;
//     }

//     // ticketReportDetailed
//     public ticketReportDetailedEndpoint(api: string): string {
//         let url = this.BASEPATH + this.ORG + this.ENV + this.V1 + this.repCapability + api;
//         return url;
//     }

//     // uploadfile
//     public uploadFileEndpoint(api: string): string {
//         let url = this.BASEPATH + this.ORG + this.ENV + this.V5 + this.dsCapability + api;
//         return url;
//     }
// }

// static lienLegalPath = "qa/v1/legal/";
// static paymentArmPath = "qa/v1/arm/";
// static paymentConfigUpload = "qa/v4/ds/";
// static paymentandInvoiceConfigEmail = "qa/v1/rc/";
// static paymentCrmPath = "qa/v1/crm/";
// static paymentCumPath = "qa/v1/cum/";
// static paymentPePath = "qa/v1/pe/";
// static paymentRcPath = "qa/v1/rc/";
// static paymentDsPath = 'qa/v1/ds/';
